<template>
  <aside class="sidebar-top"
         @mouseleave="hideMessages"
         :class="{'sidebar-top_full': !showFull}">
    <div class="top-link_cont"
         v-if="!isDashboard"
         @click="hideMessages">
      <router-link  :to="topLink.link"
                    class="top-link">
        <component :fill='"#29ABE2"'
                   class="top-link_icon"
                   :is="topLink.icon"></component>
        <p class="link-name">{{topLink.text}}</p>
      </router-link>

      <things-routes v-if="topLink.marker === 'things'"></things-routes>

      <projects-routes v-if="topLink.marker === 'projects'"></projects-routes>

      <journal-routes v-if="topLink.marker === 'journals'"></journal-routes>

      <projects-things-routes v-if="topLink.marker === 'projectThings'"></projects-things-routes>

      <project-item-things-routes v-if="topLink.marker === 'projectItemThings'"></project-item-things-routes>

      <project-roles-routes v-if="topLink.marker === 'projectRoles'"></project-roles-routes>

      <project-item-roles-routes v-if="topLink.marker === 'projectItemRoles'"></project-item-roles-routes>

      <bread-icon v-if="routeName && ($route.name !== 'journalMultithingInProject') && ($route.name !== 'ThingsInProject')"
                  class="bread-icon"></bread-icon>

      <trim-item v-if="($route.name !== 'journalMultithingInProject') && ($route.name !== 'ThingsInProject')"
                 :string="routeName"
                 :offset="60"
                 :width="50">
      </trim-item>
    </div>

    <form class="search-form"
          @click="hideMessages"
          :class="{'search-form_small': !isDashboard, 'search-from_big': !isDashboard && bigForm}">
      <label class="search-cont">
        <search-icon></search-icon>
        <input type="text"
               @focus="showBigForm"
               @blur="hideBigForm"
               :placeholder="$t('menu.search')">
      </label>
    </form>
    <div class="client-profile-link">
      <div class="profile-link"  @mouseleave="setShowSubmenu(false); showAsigned = false">
        <div class="link-left">
          <h3 class="name">{{name}} {{surname}}</h3>
          <assigned-roles :open="showAsigned"
                          @close="showAsigned = false"
                          @open="showAsigned = true"></assigned-roles>
        </div>
        <div class="submenu-wrap" @click="setShowSubmenu(!showSubmenu)">
          <div class="link-right"
               :class="{'link-right_profile': isProfile, 'link-right_border': !avatar}">
            <img :src="avatar"
                 class="avatar-img"
                 alt=""
                 v-if="avatar">
            <svg v-else width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="14" y="16" width="32" height="28">
                <path d="M17.2 19.1111H22L25.2 16H34.8L38 19.1111H42.8C43.6487 19.1111 44.4626 19.4389 45.0627 20.0223C45.6629 20.6058 46 21.3971 46 22.2222V40.8889C46 41.714 45.6629 42.5053 45.0627 43.0888C44.4626 43.6722 43.6487 44 42.8 44H17.2C16.3513 44 15.5374 43.6722 14.9373 43.0888C14.3371 42.5053 14 41.714 14 40.8889V22.2222C14 21.3971 14.3371 20.6058 14.9373 20.0223C15.5374 19.4389 16.3513 19.1111 17.2 19.1111V19.1111ZM30 23.7778C27.8783 23.7778 25.8434 24.5972 24.3431 26.0558C22.8429 27.5145 22 29.4928 22 31.5556C22 33.6184 22.8429 35.5967 24.3431 37.0553C25.8434 38.5139 27.8783 39.3333 30 39.3333C32.1217 39.3333 34.1566 38.5139 35.6569 37.0553C37.1571 35.5967 38 33.6184 38 31.5556C38 29.4928 37.1571 27.5145 35.6569 26.0558C34.1566 24.5972 32.1217 23.7778 30 23.7778V23.7778ZM30 26.8889C31.273 26.8889 32.4939 27.3806 33.3941 28.2557C34.2943 29.1309 34.8 30.3179 34.8 31.5556C34.8 32.7932 34.2943 33.9802 33.3941 34.8554C32.4939 35.7306 31.273 36.2222 30 36.2222C28.727 36.2222 27.5061 35.7306 26.6059 34.8554C25.7057 33.9802 25.2 32.7932 25.2 31.5556C25.2 30.3179 25.7057 29.1309 26.6059 28.2557C27.5061 27.3806 28.727 26.8889 30 26.8889V26.8889Z" fill="#9E9E9E"/>
              </mask>
              <g mask="url(#mask0)">
                <rect width="60" height="60" fill="#109CF1"/>
              </g>
            </svg>
          </div>
          <transition name="fade">
<!--            showSubmenu-->
            <submenu v-if="showSubmenu"></submenu>
          </transition>
        </div>
      </div>
      <div class="messages-cont">
        <button type="button"
                @click="toggleMesssages"
                :class="{'bell-btn_active': activeBtn}" class="bell-btn">
          <bell-icon
            :opacity="bellColors.opacity"
            :fill="bellColors.fill"
            :stroke="bellColors.stroke"></bell-icon>
          <div class="new-label" v-if="allNotify.length"></div>
        </button>

        <transition name="fade">
          <notifications-list v-if="activeBtn"
                              :allNotify="allNotify"
                              @mouseleave="hideMessages"></notifications-list>
        </transition>
      </div>
    </div>
  </aside>
</template>

<script>
  import searchIcon from '../Svg/searchIcon'
  import bellIcon from '../Svg/bellIcon'
  import {mapState,mapMutations, mapActions} from 'vuex'

  import homeIcon from '../Svg/sidebar/homeIcon'
  import scriptsIcon from '../Svg/sidebar/scriptsIcon'
  import usersIcon from '../Svg/sidebar/usersIcon'
  import thingsIcon from '../Svg/sidebar/thingsIcon'
  import vidgetsIcon from '../Svg/sidebar/vidgetsIcon'
  import dashboardIcon from '../Svg/sidebar/dashboardicon'
  import logsIcon from '../Svg/sidebar/logsIcon'
  import toggleIcon from '../Svg/sidebar/toggleIcon'
  import langSwitcher from '../langSwitcher'
  import breadIcon from '../Svg/breadscrumbs'
  import dotsIcon from '../Svg/sidebar/dots'
  import breadItem from './breadItem'
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import submenu from './submenu'
  import notificationsList from './notificationList'
  import assignedRoles from './assignedRoles'
  import {filters} from "../../mixins/filters";
  import thingsRoutes from './routes/things'
  import trimItem from '../trimITem'
  import projectsIcon from '../Svg/sidebar/projectsIcon'
  import projectsRoutes from './routes/projects'
  import journalIcon from '../Svg/journalRouteIcon'
  import journalRoutes from './routes/journalRoutes'
  import projectsThingsRoutes from './routes/projectThings/projectThings'
  import projectItemThingsRoutes from './routes/projectThings/projectItemThings'
  import projectRolesRoutes from './routes/projectRoles/projectRoles'
  import projectItemRolesRoutes from './routes/projectRoles/projectItemRoles'

  export default {
    name: 'sidebarTop',
    mixins: [tokenAndRoute, filters],
    components: {
      searchIcon,
      bellIcon,
      homeIcon,
      scriptsIcon,
      usersIcon,
      thingsIcon,
      vidgetsIcon,
      dashboardIcon,
      logsIcon,
      toggleIcon,
      langSwitcher,
      breadIcon,
      dotsIcon,
      breadItem,
      submenu,
      notificationsList,
      assignedRoles,
      thingsRoutes,
      trimItem,
      projectsIcon,
      projectsRoutes,
      journalRoutes,
      projectsThingsRoutes,
      projectItemThingsRoutes,
      projectRolesRoutes,
      projectItemRolesRoutes
    },
    data() {
      return {
        //activeBtn: false,
        bigForm: false,
        showLangSwitcher: false,
        showAsigned: false,
      }
    },
    computed: {
      ...mapState({
        routeName: state => state.sidebar.routeName,
        routeLink: state => state.sidebar.linkName,
        isDashboard: state => state.sidebar.isDashboard,
        isProfile: state => state.sidebar.isProfile,
        showFull: state => state.sidebar.showFull,
        name: state => state.profile.name,
        surname: state => state.profile.surname,
        avatar: state => state.profile.avatar,
        activeBtn: state => state.sidebar.showLogs,
        showSubmenu: state => state.sidebar.showSubmenu,
        allNotify: state => state.roles.allNotify
      }),
      routes() {
       return [
          {
            marker: 'home',
            icon: homeIcon,
            text: this.$t('menu.home'),
            link: '/'
          },
          {
            marker: 'scripts',
            icon: scriptsIcon,
            text: this.$t('menu.scripts'),
            link: '/scripts'
          },
          {
            marker: 'users',
            icon: usersIcon,
            text: this.$t('menu.users'),
            link: '/users'
          },
          {
            marker: 'things',
            icon: thingsIcon,
            text: this.$t('menu.things'),
            link: '/things'
          },
          {
            marker: 'vidgets',
            icon: vidgetsIcon,
            text: this.$t('menu.vidgets'),
            link: '/vidgets'
          },
          {
            marker: 'dashboards',
            icon: dashboardIcon,
            text: this.$t('menu.dashboards'),
            link: '/dashboards'
          },
          {
            marker: 'logs',
            icon: logsIcon,
            text: this.$t('menu.logs'),
            link: '/logs'
          },
         {
           marker: 'roles',
           icon: usersIcon,
           text: this.$t('menu.users'),
           link: '/roles'
         },
         {
           marker: 'projects',
           icon: projectsIcon,
           text: this.$t('menu.projects'),
           link: '/projects'
         },
         {
           marker: 'journals',
           icon: journalIcon,
           text: this.$t('index.journal.title'),
           link: '/journals'

         },
         {
           marker: 'projectThings',
           icon: thingsIcon,
           text: this.$t('menu.things'),
           link: '/things'
         },
         {
           marker: 'projectItemThings',
           icon: thingsIcon,
           text: this.$t('menu.things'),
           link: '/things'
         },
         {
           marker: 'projectRoles',
           icon: usersIcon,
           text: this.$t('menu.users'),
           link: '/users'
         },
         {
           marker: 'projectItemRoles',
           icon: usersIcon,
           text: this.$t('menu.users'),
           link: '/users'
         }
        ]
      },
      // submenuName() {
      //   switch (this.routeName) {
      //     case 'Бортовой журнал': return this.$t('menu.submenu.journal');
      //       break;
      //     case 'Мой профиль': return this.$t('menu.submenu.profile')
      //     default: return this.routeName
      //   }
      // },
      bellColors() {
        if (this.activeBtn) {
          return {
            fill: '#29ABE2',
            stroke: 'white',
            opacity: '1'
          }
        } else {
          return {
            fill: 'white',
            stroke: '#00527F',
            opacity: '0.4'
          }
        }
      },
      topLink() {
        let obj = {};
        for(let i = 0; i < this.routes.length; i++) {
          if (this.routeLink === this.routes[i].marker) {
            obj = this.routes[i];
            break
          }
        };
        return obj;
      }
    },
    methods: {
      ...mapMutations({
        setShowLogs: 'sidebar/SET_SHOW_LOGS',
        setShowSubmenu: 'sidebar/SET_SHOW_SUBMENU'
      }),
      ...mapActions({
        loadUser: 'auth/loadUser',
        loadAssignedRoles: 'roles/getAssignedRoles',
        getAllNotify: 'roles/getAllNotify',
        getProjects: 'projects/getProjects'
      }),
      checkId(id) {
        return this.routeId != id
      },
      toggleMesssages() {
        this.setShowLogs(!this.activeBtn);
        this.getAllNotify()
      },
      hideMessages() {
        this.setShowLogs(false);
      },
      showBigForm() {
        if (!this.isDashboard) {
          this.bigForm = true
        }
      },
      hideBigForm() {
        if (!this.isDashboard) {
          this.bigForm = false
        }
      }
    },
    mounted() {
      // console.log('fromMounted', fromMounted)
      let token = localStorage.getItem('token');
      if (!!token && token != null && token != 'null') {
        this.loadUser();
        this.getProjects();
        this.loadAssignedRoles(this.token);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .avatar-img {
    width: auto;
    height: 100%;
  }
  .sidebar-top {
    background: white;
    min-height: 90px;
    width: calc(100% - 240px);
    right: 0;
    top: 0;
    position: fixed;
    z-index: 9;
    box-shadow: 0px 1px 0px #F5F8FA;
    transition: $anim;
  }

  .hierarchy-cont {
    position: relative;

    &:hover {
      .hierarchy-list {
        opacity: 1;
        z-index: 2;
        display: block;
      }
    }
  }

  .hierarchy-list {
    position: absolute;
    background: white;
    top: calc(100% + 5px);
    left: -20px;
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
    opacity: 0;
    z-index: -99;
    display: none;


    &::before {
      content: '';
      position: absolute;
      width: 11px;
      height: 11px;
      background: white;
      transform: rotate(45deg);
      left: 20px;
      top: -5px;
    }
  }

  .hierarchy-item {
    min-height: 50px;
    box-shadow: 0px 1px 0px #F5F8FA;
    padding: 0 20px;
    display: flex;
    align-items: center;


    a {
      font-family: $msb;
      font-size: 12px;
      letter-spacing: .15px;
      color: $darkBlue;
      transition: $anim;
    }

    &:last-of-type {
      box-shadow: none;
    }

    &:hover a {
      color: $lightBlue;
    }
  }

  .sidebar-top_full {
    width: calc(100% - 60px);
  }


    .top-link_cont {
      display: flex;
      align-items: center;
      padding-left: 30px;
      margin-right: 70px;
      max-width: 55%;

      @media screen and (max-width: 1280px) {
        margin-right: 20px;
      }

      .top-link {
        display: flex;
        align-items: center;
        //margin-right: 60px;

        @media screen and (max-width: 1280px) {
          //margin-right: 20px;
        }

        .link-name {
          color: $lightBlue;
        }
      }

      .bread-icon {
        margin: 0 30px;
        min-width: 6px;

        @media screen and (max-width: 1280px) {
          margin: 0 10px;
        }
      }

      .top-link_icon {
        margin-right: 20px;
      }
    }

    .link-name {
      font-family: $mm;
      font-size: 14px;
      letter-spacing: 0.25px;
      color: $darkBlue;
      white-space: nowrap;
    }

    .sidebar-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 22px 20px 10px;
    }

    .client-profile-link {
      display: flex;
      align-items: center;
    }

    .profile-link {
      display: flex;
      align-items: center;
      text-align: right;
      margin-right: 16px;
      padding-bottom: 12px;
      transform: translateY(6px);
    }

    .name {
      font-family: $msb;
      font-size: 14px;
      letter-spacing: 0.25px;
      color: $darkBlue;
      line-height: 14px;
      //margin-bottom: 5px;
      white-space: nowrap;
      padding-right: 10px;
    }



    .link-left {
      margin-right: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    .submenu-wrap {
      position: relative;
    }

    .link-right {
      width: 46px;
      height: 46px;
      overflow: hidden;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 50%;

      img {
        width: 100%;
        height: auto;
      }

      svg {
        width: 100%;
        //height: 100%;
      }
    }

    .link-right_profile {
      border: 1px solid white;
      box-shadow: 0 0 0 2px $green;

    }

    .link-right_border {
      border: 1px solid $lightBlue;
    }

    .bell-btn {
      position: relative;
      padding: 2.4px 4px;
      border: 1px solid white;

      .new-label {
        width: 8px;
        height: 8px;
        background: $red;
        border-radius: 50%;
        position: absolute;
        top: 3px;
        right: 3px;
        box-shadow: 0 0 0 1px white;
      }

      &:focus, &:hover {
        border: 1px solid $grey;
      }
    }

    .bell-btn_active {
      background: $lightBlue;
      border: 1px solid $lightBlue;

      .new-label {
        display: none;
      }
    }




    .search-form {
      width: 777/1220*100%;
      display: flex;
      justify-content: center;
      position: relative;
      transition: $anim;

      &:hover {
        input {
          border: 1px solid $lightGrey;
        }
      }

      .search-cont {
        width: 100%;
      }

      svg {
        position: absolute;
        left: 20px;
        top: 10px;
      }

      input {
        width: 100%;
        height: 40px;
        padding: 0 60px;
        font-family: $mm;
        font-size: 14px;
        color: $darkBlue;
        border-radius: 4px;
        border: 1px solid white;
        outline: none;
        transition: $anim;

        &::placeholder {
          font-family: $mm;
          font-size: 14px;
          color: $darkBlue;
        }

        &:hover, &:focus {
          border: 1px solid $lightGrey;
        }
      }
    }

  .search-form_small {
    margin-left: auto;
    width: 140px;
    margin-right: 70px;

    @media screen and (max-width: 1280px) {
      margin-right: 20px;
    }


    input {
      padding-right: 20px;
      padding-left: 45px;
      border: 1px solid $lightGrey;
    }
  }

  .search-from_big {
    width: 777/1220*100%;
  }
</style>
